import gql from 'graphql-tag';

import consultationFragment from './consultation-fragment';

export default gql`
  mutation updateByIdConsultationMutation(
    $_id: MongoID!
    $record: UpdateByIdConsultationInput!
  ) {
    updateByIdConsultationMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...ConsultationFragment
      }
      message
      title
    }
  }
  ${consultationFragment}
`;
